import { UserRelationsModel } from '@/services/apis/user/model'

import { getUserRelations } from '@/store/user'

import { WorkspaceMemberModel } from '@/services/apis/user/model'
import { setIsLocalBackup } from '@/store/user'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, AppState } from '@/store/types'

import userApi from '@/services/apis/user'
import { LocalBackupStateEnum } from '@/constants/enum'
import { BusinessType } from '@/constants/enum'
import { getWorkspaceInfo } from '@/store/user'
export const useUserList = () => {
  const userList = useSelector<AppState, UserRelationsModel[]>(state => state.user.userRelations)
  const dispatch = useDispatch<AppDispatch>()
  useEffect(() => {
    if (!userList.length) {
      dispatch(getUserRelations())
    }
  }, [])
  return userList
}

export const useSelectWorkspaceUserInfo = () => {
  return useSelector<AppState, WorkspaceMemberModel | undefined>(
    state => state.user.workspaceMember
  )
}

export const useSelectLocalBackupState = () => {
  const isLocalBackup = useSelector<AppState, boolean>(state => state.user.isLocalBackup)
  const isLoadingLocalBackup = useSelector<AppState, boolean>(
    state => state.user.isLoadingLocalBackup
  )
  return {
    isLocalBackup,
    isLoadingLocalBackup,
  }
}

export const useGetLocalBackupState = () => {
  const dispatch = useDispatch<AppDispatch>()
  useEffect(() => {
    dispatch(getWorkspaceInfo())
  }, [])
  return useSelectLocalBackupState()
}

export const useCheckBackupStatus = () => {
  const { isLocalBackup } = useSelectLocalBackupState()
  const dispatch = useDispatch<AppDispatch>()
  const refreshLocalBackupState = async (): Promise<boolean> => {
    const res = await userApi.getWorkspaceInfo()
    if (res.success) {
      const newBackup = res.data.backupState === LocalBackupStateEnum.COMPLETE
      if (newBackup !== isLocalBackup) {
        dispatch(setIsLocalBackup(res.data.backupState))
      }
      return newBackup
    }
    return false
  }
  const checkBackupStatus = async () => {
    let backup = isLocalBackup
    if (!backup) {
      backup = (await refreshLocalBackupState()) || false
    }
    return backup
  }
  return checkBackupStatus
}

export const useSendEmail = (email: string, businessType: BusinessType, initCountDown = 60) => {
  const [countDown, setCountDown] = useState(0)
  const [sendCount, setSendCount] = useState(1)
  const [businessId, setBusinessId] = useState('')
  useEffect(() => {
    if (countDown > 0) {
      return
    }
    setCountDown(initCountDown)
    userApi
      .sendEmailCode({
        email,
        businessType,
      })
      .then(res => {
        if (res.success) {
          setBusinessId(res.data.businessId)
        }
      })
  }, [sendCount])
  useEffect(() => {
    const timer = setInterval(() => {
      if (countDown > 0) {
        setCountDown(countDown - 1)
      }
    }, 1000)
    return () => {
      clearInterval(timer)
    }
  }, [countDown])
  return {
    countDown,
    businessId,
    resend: () => setSendCount(sendCount + 1),
  }
}
